export default function init_core(IconsView, iconsViewCache) {

IconsView.prototype.onOnload = function (target) {
        if (BEHAV) {
            BEHAV.apply(target);
        }
    }


IconsView.prototype.onUnload = function (target) {
        if (BEHAV) {
            BEHAV.apply(target, 'unload');
        }
    }


IconsView.prototype.timer = function () {
        this.timerLastLoad++;
        this.timerLastLoadfull++;

        /*
        console.log('option : '+ this.conf.refresh);
        console.log('loading : '+ this.isLoading);
        console.log('busy : '+ this.isBusy);
        console.log('timer : ' + this.timerLastLoad);
        */

        if (this.conf.refresh && !this.isLoading && !this.isBusy && this.timerLastLoad == this.conf.refresh) {
            if (this.dataNodeParent && this.dataNodeParent.load) {
                this.lazyLoad(this.dataNodeParent);
            } else {
                this.load();
            }
        }
    }


IconsView.prototype.init = function () {
        const myself = this;

        if (this.element.data('field')) {
            this.dataField = $('textarea[name="' + this.element.data('field') + '"]');
            if (!this.dataField.val()) this.dataField.val('[]');
            this.dataField.change(() => {
                myself.load();
            });
        }

        if (this.name) {
            this.selectionInput = this.element.parent().find('[name='+this.name+'_select]')
            if (!this.selectionInput) {
                this.selectionInput = $('<input type="hidden" name="' + this.name + ((this.element.data('field') == this.name) ? '_select' : '') + '" ' + ((this.uid) ? 'id="' + this.uid + '_select" data-id="' + this.name + '_select"':'') + ' value="' + this.value + '" />');
                this.element.before(this.selectionInput);
            }
            this.selectionInputType = this.element.parent().find('[name='+this.name+'_type]')
            if (!this.selectionInputType) {
                this.selectionInputType = $('<input type="hidden" name="' + this.name + '_type" ' + ((this.uid) ? 'id="' + this.uid + '_type" data-id="' + this.name + '_type"':'') + ' value="' + this.valueType + '" />');
                this.element.before(this.selectionInputType);
            }
            this.selectionInputLabel = this.element.parent().find('[name='+this.name+'_label]')
            if (!this.selectionInputLabel) {
                this.selectionInputLabel = $('<input type="hidden" name="' + this.name + '_label" ' + ((this.uid) ? 'id="' + this.uid + '_label" data-id="' + this.name + '_label"':'') + ' value="" />');
                this.element.before(this.selectionInputLabel);
            }
        }

        try {
            this.path = JSON.parse(getCookie(this.cookieName));
        } catch (e) {

        }

        this.loadCache();

        $(this.element).on('contextmenu', () => {
            myself.createMenu(myself.globalMenu, myself.element);
            return false;
        });

        if (this.conf.data) {
            this.loadFromData(this.conf);
        }
    };


}
